<template>
  <div>
    <b-button v-b-modal.modal-client-card-sell variant="success">
      Продажа карти
      <b-icon class="ms-1" icon="calendar2-check-fill"></b-icon>
    </b-button>
    <b-modal
      :hide-footer="true"
      class="seller-modal"
      size="lg"
      id="modal-client-card-sell"
      title="Продажа карти"
      centered
      @hide="resetStates"
    >
      <div v-if="chooseState">
        <b-tabs>
          <b-tab
            v-for="variant in cardVariants"
            :key="variant.training_type"
            :title="variant.title"
          >
            <b-row>
              <div
                class="col-sm-auto col-lg-3 align-items-stretch my-2"
                v-for="card in sortCards(variant.training_type)"
                :key="card.id"
              >
                <b-card
                  :header="card.name"
                  bg-variant="secondary"
                  header-bg-variant="dark"
                  header-text-variant="light"
                  class="product h-100"
                >
                  <b-card-body class="h5 price text-white p-0 m-auto">
                    {{ card.cost }} грн
                    <b-icon
                      icon="cart-check-fill"
                      @click="chooseStateSwitch(card)"
                    >
                    </b-icon>
                  </b-card-body>
                </b-card>
              </div>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>
      <div v-if="trainerState">
        <b-form-input
          v-model="trainerSearch"
          placeholder="Пошук від 2-ох літер"
        >
        </b-form-input>
        <b-list-group
          class="mt-2"
          v-for="trainer in filteredTrainers"
          :key="trainer.id"
        >
          <b-list-group-item v-on:click="trainerStateSwitch(trainer)">
            <b-avatar class="me-3" :src="trainerPicUrl(trainer.id)"></b-avatar>
            <span>{{ trainer.name }} {{ trainer.surname }}</span>
          </b-list-group-item>
        </b-list-group>
      </div>
      <div v-if="checkoutState" class="text-center">
        <div>
          <p class="h2">Інформація</p>
          <hr />
          <p>
            Карта : <strong>{{ chosenCard.name }}</strong>
          </p>
          <p>
            Кількість тренуваннь :
            <strong>{{
              chosenCard.trainings === "unlimited"
                ? "Безліміт"
                : chosenCard.trainings
            }}</strong>
          </p>
          <p
            v-if="
              chosenCard.training_type === 1 || chosenCard.training_type === 4
            "
          >
            Тренер :
            <strong>
              {{ chosenTrainer.name }} {{ chosenTrainer.surname }}</strong
            >
          </p>
          <p>
            Вартість : <strong> {{ chosenCard.cost }} грн</strong>
          </p>
          <b-form-checkbox switch v-model="activated"
            >Активувати?</b-form-checkbox
          >
          <b-form-radio-group
            v-if="activated"
            v-model="activatedToday"
            :options="activationOptions"
            class="mb-3 mt-3"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
          ></b-form-radio-group>
          <b-form-datepicker
            :max="new Date(Date.now())"
            v-if="!activatedToday && activated"
            v-model="activationDate"
          >
          </b-form-datepicker>
        </div>
        <hr />
        <div>
          <p class="h2">Оплата</p>
          <hr />
          Знижка :
          <b-input-group class="w-25 mt-2 mx-auto" size="sm">
            <template #prepend>
              <div class="mt-2 me-2">
                {{ percentDiscount }}
              </div>
            </template>
            <template #append>
              <div class="mt-2 ms-2">%</div>
            </template>
            <b-form-input
              type="range"
              min="0"
              max="100"
              @change="evaluateDiscounts('%')"
              v-model="percentDiscount"
            >
            </b-form-input>
          </b-input-group>
          <b-form-group>
            <b-input-group
              invalid-feedback="Сумма першого платежу не може бути більше вартості карти!"
              class="w-25 mt-2 mx-auto"
              size="sm"
            >
              <template #append>
                <div class="mt-2 ms-2">грн.</div>
              </template>
              <b-form-input
                class="ms-3"
                type="number"
                @change="evaluateDiscounts('uah')"
                v-model="uahDiscount"
                @blur="$v.uahDiscount.$touch()"
                :class="{
                  'is-invalid': $v.uahDiscount.$error && $v.uahDiscount.$dirty,
                }"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
          <p class="mt-3">
            Вартість карти : <strong> {{ finalSum }} грн</strong>
          </p>
        </div>
        <b-form-checkbox v-model="debtPayment" switch>
          Розстрочка
        </b-form-checkbox>
        <div class="mt-2" v-if="debtPayment">
          <label>Перший платіж</label>
          <b-form-group
            class="w-25 mx-auto"
            size="sm"
            invalid-feedback="Сумма першого платежу не може бути більше вартості карти!"
          >
            <template #append>
              <div class="mt-2 ms-2">грн.</div>
            </template>
            <b-form-input
              @blur="$v.firstPayment.$touch()"
              type="number"
              v-model="firstPayment"
              :class="{
                'is-invalid': $v.firstPayment.$error && $v.firstPayment.$dirty,
              }"
            >
            </b-form-input>
          </b-form-group>
        </div>
        <div class="mt-2">
          <p v-if="debtPayment">
            Сума до оплати : <strong>{{ firstPayment }} грн</strong> ( Борг :
            <strong>{{ finalSum - firstPayment }} грн</strong> )
          </p>
          <p v-else>
            Сумма до оплати : <strong>{{ finalSum }} грн</strong>
          </p>
        </div>
        <div class="mt-2">
          <b-form-select
            class="w-25"
            :options="paymentOptions"
            v-model="paymentType"
          >
          </b-form-select>
        </div>
        <b-button @click="sellCard" class="mt-2" variant="outline-success"
          >Продажа</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

import { maxValue } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  name: "ClientCardSeller",
  props: {
    clientId: Number,
  },
  data: function () {
    return {
      cardList: [],
      trainersList: [], // ? isnt it better to make trainersearch dynamic like client search?
      filteredTrainers: [],
      cardVariants: [
        { training_type: 1, title: "Персональні тренування" },
        { training_type: 2, title: "Группові тренування" },
        { training_type: 3, title: "Тренажерний зал" },
        { training_type: 4, title: "Массажі" },
      ],
      chooseState: true,
      trainerState: false,
      checkoutState: false,
      trainerSearch: "",
      chosenCard: {},
      chosenTrainer: {},
      percentDiscount: 0,
      uahDiscount: 0,
      finalSum: 0,
      firstPayment: 0,
      debtPayment: false,
      paymentOptions: [
        { value: 1, text: "Готівка" },
        { value: 2, text: "Карта" },
      ],
      paymentType: 1,
      activated: false,
      activationOptions: [
        { item: true, name: "Сьогодні" },
        { item: false, name: "Інший час" },
      ],
      activationDate: null,
      activatedToday: true,
    };
  },
  validations() {
    return {
      firstPayment: { maxValue: maxValue(this.finalSum) },
      uahDiscount: { maxValue: maxValue(this.chosenCard.cost) },
    };
  },
  watch: {
    trainerSearch: function (newVal) {
      if (newVal.length < 2) {
        this.filteredTrainers = [];
        return;
      }
      this.filteredTrainers = this.trainersList.filter((trainer) => {
        return (
          trainer.name.includes(capitalizeFirstLetter(newVal)) ||
          trainer.surname.includes(capitalizeFirstLetter(newVal))
        );
      });
    },
    chosenCard: function (newVal) {
      this.finalSum = newVal.cost;
    },
  },
  async mounted() {
    await this.getCardsList();
  },
  methods: {
    async getCardsList() {
      let response = await this.$api.products.getCards();
      this.cardList = response.data;
    },
    trainerPicUrl(trainer) {
      return process.env.VUE_APP_API + "/trainers/photo/" + trainer;
    },
    async getTrainers() {
      let response = await this.$api.trainers.getTrainersList();
      this.trainersList = response.data;
    },
    sortCards(cardType) {
      return this.cardList.filter((card) => card.training_type === cardType);
    },
    evaluateDiscounts(event) {
      if (event === "%") {
        this.uahDiscount = (
          (this.chosenCard.cost / 100) *
          this.percentDiscount
        ).toFixed(2);
        this.finalSum = this.chosenCard.cost - this.uahDiscount;
      } else if (event === "uah") {
        this.percentDiscount = (
          100 -
          (this.chosenCard.cost - this.uahDiscount) /
            (this.chosenCard.cost / 100)
        ).toFixed(2);
        this.finalSum = this.chosenCard.cost - this.uahDiscount;
      }
    },
    async sellCard() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log(this.chosenCard.cost === this.uahDiscount);
        return;
      }
      let payload = {
        product_id: this.chosenCard.id,
        amount: !this.debtPayment ? this.finalSum : this.firstPayment,
        discount: Number(this.percentDiscount).toFixed(0),
        payment_type: this.paymentType,
        client_id: this.clientId,
        activated: this.activated,
        debt: this.debtPayment,
        trainer: this.chosenTrainer ? this.chosenTrainer.id : null,
      };
      if (!this.activatedToday && this.activationDate) {
        payload.activation_date = moment(this.activationDate).format(
          "YYYY-MM-DD",
        );
      }
      await this.$api.activecards.sellCard(payload);
      this.$emit("refresh");
      this.$emit("showModal", "Карта продана успішно!", "green");
      this.$nextTick(() => {
        this.$bvModal.hide("modal-client-card-sell");
      });
    },
    async chooseStateSwitch(card) {
      this.chosenCard = card;
      if (card.training_type === 3 || card.training_type === 2) {
        this.chooseState = false;
        this.checkoutState = true;
        return;
      }
      await this.getTrainers();
      this.chooseState = false;
      this.trainerState = true;
    },
    trainerStateSwitch(trainer) {
      this.chosenTrainer = trainer;
      this.trainerState = false;
      this.checkoutState = true;
    },
    resetStates() {
      this.trainerState = false;
      this.checkoutState = false;
      this.chosenTrainer = {};
      this.chosenCard = {};
      this.uahDiscount = 0;
      this.percentDiscount = 0;
      this.chooseState = true;
      this.trainerSearch = "";
      this.debtPayment = false;
      this.firstPayment = 0;
      this.paymentType = 1;
      this.activated = true;
      this.activationDate = null;
      this.activatedToday = true;
    },
  },
};
</script>

<style scoped></style>
